import type { FC } from 'react';
import React from 'react';

import type { PageCardContextProviderProps } from './PageCardContextProvider.tsx';
import { CompactEndOfPageView, EndOfPageView } from './Views/index.ts';
import { AISnippetPageRecExperiment } from './Items/AISnippet/AISnippetPageRecExperiment.tsx';

type EndOfPageCardProps = Omit<PageCardContextProviderProps, 'appearance'> & {
	isCompactView?: boolean;
	showCardsAsListitem?: boolean;
};

export const EndOfPageCard: FC<EndOfPageCardProps> = (wrapperProps) => {
	return (
		<AISnippetPageRecExperiment wrapperProps={wrapperProps} isCompactView>
			{() =>
				wrapperProps.isCompactView ? (
					<CompactEndOfPageView showCardsAsListitem={wrapperProps.showCardsAsListitem} />
				) : (
					<EndOfPageView showCardsAsListitem={wrapperProps.showCardsAsListitem} />
				)
			}
		</AISnippetPageRecExperiment>
	);
};
